import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgTemplate() {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("rect", {
      x: 3,
      y: 3,
      width: 18,
      height: 18,
      rx: 1,
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0), _jsx("path", {
      opacity: 0.9,
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      d: "M8 7v7"
    }, void 0), _jsx("path", {
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      d: "M12 7v5M16 7v10"
    }, void 0)]
  }), void 0);
}

export default SvgTemplate;